import SoftBox from "components/SoftBox";
import React, { useEffect, useRef, useState } from "react";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";
import "./accountDetailTabs.css";

const FIELD_LABELS = {
  facebook: "Facebook link",
  twitter: "Twitter link",
  instagram: "Instagram link",
  linked_in: "LinkedIn link",
  youtube: "YouTube link",
};

const SOCIAL_FIELDS = Object.keys(FIELD_LABELS);

function SocialUrl({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [currentFormData, setCurrentFormData] = useState({
    facebook: "",
    twitter: "",
    instagram: "",
    linked_in: "",
    youtube: "",
  });
  const formDataRef = useRef(formData);

  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    if (formData) {
      setCurrentFormData(formData);
    }
  }, [formData]);

  const persistFields = async (fields, successMessage) => {
    const accountId = currentFormData?.id ?? formData?.id;
    if (!accountId) {
      toast.error("Business account not found");
      return false;
    }

    try {
      const payload = {
        _id: accountId,
        agency_id: formDataRef.current?.agency_id,
        ...fields,
      };
      const { response, error } = await AppService.accounts.update({ payload });
      if (error || response?.success === false) {
        toast.error(error?.message || response?.message || "Failed to save social link");
        return false;
      }
      setCurrentFormData((prev) => ({ ...prev, ...fields }));
      await handleRefresh?.();
      toast.success(successMessage);
      return true;
    } catch (err) {
      console.error("Social link save failed:", err);
      toast.error("Failed to save social link");
      return false;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFieldBlur = (e) => {
    const { name, value } = e.target;
    if (!SOCIAL_FIELDS.includes(name)) return;

    const savedValue = formDataRef.current?.[name] ?? "";
    if (String(value ?? "") === String(savedValue ?? "")) return;

    persistFields({ [name]: value }, `${FIELD_LABELS[name]} saved`);
  };

  return (
    <div className="sd-account-detail-tab">
      <div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Facebook</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Facebook"
                name="facebook"
                value={currentFormData.facebook || ""}
              />
            </SoftBox>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Twitter</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Twitter"
                name="twitter"
                value={currentFormData.twitter || ""}
              />
            </SoftBox>
          </div>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Instagram</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Instagram"
                name="instagram"
                value={currentFormData.instagram || ""}
              />
            </SoftBox>

            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">LinkedIn</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="LinkedIn"
                name="linked_in"
                value={currentFormData.linked_in || ""}
              />
            </SoftBox>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Youtube</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Youtube"
                name="youtube"
                value={currentFormData.youtube || ""}
              />
            </SoftBox>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SocialUrl;
